import React from 'react';
import WrappedBase from './WrappedBase';

import MembershipQueryParamCheck from '../containers/MembershipQueryParamCheck';

export default class MembershipQueryParamCheckWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <MembershipQueryParamCheck />
      </WrappedBase>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/wrapped/MembershipQueryParamCheck.js